import {
	GenerateProductDto,
	ProductCreateUpdateDto,
	ProductDto,
} from '../../../interface/product';
import { ProductType } from '../../../interface/subscriptionProducts';
import { axiosInstance } from '../../../network/axios';

import { ListResponse, ObjectResponse } from '../@types';
import { authApiSlice } from '../query';

const productApiSlice = authApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// 전체 상품 조회
		getProducts: builder.query<ListResponse<ProductDto>, Record<any, any>>({
			query: (args) => ({
				method: 'GET',
				url: `/members/products`,
				params: args,
			}),
			providesTags: ['Products'],
		}),

		// 개별 상품 상세 조회
		getProductDetail: builder.query<
			ObjectResponse<ProductDto>,
			{ productId: string | undefined }
		>({
			query: ({ productId }) => ({
				method: 'GET',
				url: `/members/products/${productId}`,
			}),
			providesTags: (result, error, { productId }) => [
				{ type: 'Product', id: productId },
			],
		}),

		// 개별 상품 생성
		createIndividualProduct: builder.mutation<
			ObjectResponse<ProductDto>,
			ProductCreateUpdateDto
		>({
			query: (body) => ({
				method: 'POST',
				url: '/members/products',
				body,
			}),
			invalidatesTags: ['Products'],
		}),

		// 개별 상품 업데이트
		updateIndividualProduct: builder.mutation<
			ObjectResponse<ProductDto>,
			{ id: number; body: ProductCreateUpdateDto }
		>({
			query: ({ id, body }) => ({
				method: 'PUT',
				url: `/members/products/${id}`,
				body,
			}),
			invalidatesTags: (result, error, { id }) => [
				'Products',
				{ type: 'Product', id },
			],
		}),

		// 개별 상품 삭제
		deleteIndividualProduct: builder.mutation<
			ObjectResponse<ProductDto>,
			string
		>({
			query: (id) => ({
				method: 'DELETE',
				url: `/members/products/${id}`,
			}),
			invalidatesTags: ['Products'],
		}),
	}),
});

export const getProductModalList = async (productType: ProductType) => {
	const url = `/members/products`;
	const { data } = await axiosInstance.get<ListResponse<GenerateProductDto>>(
		url,
		{ params: { productType } },
	);

	return data.rows;
};

export const {
	useGetProductsQuery,
	useGetProductDetailQuery,
	useUpdateIndividualProductMutation,
	useCreateIndividualProductMutation,
	useDeleteIndividualProductMutation,
} = productApiSlice;
